// extracted by mini-css-extract-plugin
export default {"icon":"FavoriteIcon_icon__Js64X","root":"FavoriteIcon_root__w7XGd"};